// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1qB9Y","head":"Table_head__36mk9","col":"Table_col__2RXbY"};